import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';





import { BadRequestHandler, HttpResponseStatus, GlobalMessageType, Priority, ErrorModel, isCartNotFoundError, TranslationService, GlobalMessageService } from '@spartacus/core';

const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';

@Injectable({
  providedIn: 'root',
})
export class EkBadRequestHandler extends BadRequestHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;
  constructor(
      private translationService: TranslationService,
      public _globalMessageService: GlobalMessageService
      ) { 
      super(_globalMessageService)
  }
  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleBadPassword(request, response);
    this.handleBadLoginResponse(request, response);
    this.handleBadCartRequest(request, response);
    this.handleValidationError(request, response);
    this.handleVoucherOperationError(request, response);
    this.handleGuestDuplicateEmail(request, response);
  }

  protected handleBadPassword(
    request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    if (
      response.url?.includes(OAUTH_ENDPOINT) &&
      response.error?.error === 'invalid_grant' &&
      response.error?.error_description === "User is disabled" && 
      request.body?.get('grant_type') === 'password'
    ) {
        this.translationService
      .translate('httpHandlers.expiryRequestPleaseLoginAgain',{
        path: 'customerservices.usa@lipton.com'}
      )
      .subscribe((data) => {
        if (data) {
            this._globalMessageService.add(
              data ?? '',
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
      });
      
      this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }else if (
        response.url?.includes(OAUTH_ENDPOINT) &&
      response.error?.error === 'invalid_grant' &&
      response.error?.error_description !== "User is disabled" && 
      request.body?.get('grant_type') === 'password'
    ){
        this.globalMessageService.add(
            {
              key: 'httpHandlers.badRequestPleaseLoginAgain',
              params: {
                errorMessage:
                  response.error.error_description || '',
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR
          );
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }

  protected handleBadLoginResponse(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ) {
    this.getErrors(response)
      .filter((error) => error.type === 'PasswordMismatchError')
      .forEach(() => {
        this.globalMessageService.add(
          { key: 'httpHandlers.badRequestOldPasswordIncorrect' },
          GlobalMessageType.MSG_TYPE_INFO
        );
      });
  }

  protected handleValidationError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'ValidationError')
      .forEach((error) => {
        this.globalMessageService.add(
          {
            key: `httpHandlers.validationErrors.${error.reason}.${error.subject}`,
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected handleBadCartRequest(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => isCartNotFoundError(e))
      .forEach(() => {
        this.globalMessageService.add(
          { key: 'httpHandlers.cartNotFound' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected handleVoucherOperationError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter(
        (e) =>
          e.message === 'coupon.invalid.code.provided' &&
          e.type === 'VoucherOperationError'
      )
      .forEach(() => {
        this.globalMessageService.add(
          { key: 'httpHandlers.invalidCodeProvided' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected handleGuestDuplicateEmail(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'DuplicateUidError')
      .forEach((error) => {
        this.globalMessageService.add(
          {
            key: 'httpHandlers.badRequestGuestDuplicateEmail',
            params: {
              errorMessage: error.message || '',
            },
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected getErrors(response: HttpErrorResponse): ErrorModel[] {
    return (response.error?.errors || []).filter(
      (error: { type: string; }) => error.type !== 'JaloObjectNoLongerValidError'
    );
  }

  getPriority(): Priority {
    return Priority.LOW;
  }
}